import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "viewPortSize", "cutout", "rounding"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getLogoSize = function getLogoSize(size) {
  if (size >= 240) {
    return 40;
  }
  return size >= 160 ? 32 : 20;
};
var convertSizeToNumber = function convertSizeToNumber(size) {
  if (typeof size !== 'string') {
    return size || 80;
  }
  if (size === 'l') {
    return 240;
  }
  return size === 'm' ? 160 : 80;
};
export var dataConverter = function dataConverter(props) {
  var _props$size = props.size,
    sizeProp = _props$size === void 0 ? 'm' : _props$size,
    _props$viewPortSize = props.viewPortSize,
    viewPortSize = _props$viewPortSize === void 0 ? 1000 : _props$viewPortSize,
    cutoutProp = props.cutout,
    _props$rounding = props.rounding,
    rounding = _props$rounding === void 0 ? 60 : _props$rounding,
    otherProps = _objectWithoutProperties(props, _excluded);
  var cutout = typeof cutoutProp === 'boolean' ? cutoutProp : !!(otherProps.image || otherProps.children);
  var size = convertSizeToNumber(sizeProp);
  return _objectSpread({
    size: size,
    cutout: cutout,
    viewPortSize: viewPortSize,
    rounding: Math.min(rounding, 100),
    scale: viewPortSize / size
  }, otherProps);
};